import React, { useEffect, useState } from 'react';
import api from '../services/api';
import './TopluSms.css';

// RANDEVU MODÜLÜ — TOPLU SMS (kullanıcı talebi: 2026-09-21).
// VB6 karşılığı: Randevu_VB6\SERBEST_SMS.frm (VB6'daki "Serbest SMS" adı kullanıcı isteğiyle
// "Toplu SMS" olarak değiştirildi).
//
// Hasta seçimi YOKTUR: kullanıcı telefon listesini yapıştırır, tek mesaj toplu gönderilir.
// Numaralar sağlayıcıya TEK istekte virgülle ayrılmış olarak gider (VB6 ile aynı).

export default function TopluSms() {
  const [numaralar, setNumaralar] = useState('');
  const [mesaj, setMesaj] = useState('');
  const [onizleme, setOnizleme] = useState(null);
  const [sonuc, setSonuc] = useState(null);
  const [gonderiliyor, setGonderiliyor] = useState(false);
  const [hata, setHata] = useState('');
  const [bilgi, setBilgi] = useState('');

  // Liste değiştikçe ayrıştırma sunucuda yapılır — sağlayıcıya hiçbir istek gitmez.
  useEffect(() => {
    if (!numaralar.trim()) { setOnizleme(null); return undefined; }
    const z = setTimeout(() => {
      api.post('/toplu-sms/onizle', { numaralar })
        .then(({ data }) => setOnizleme(data))
        .catch(() => setOnizleme(null));
    }, 350);
    return () => clearTimeout(z);
  }, [numaralar]);

  useEffect(() => {
    if (!bilgi) return undefined;
    const z = setTimeout(() => setBilgi(''), 10000);
    return () => clearTimeout(z);
  }, [bilgi]);

  const gonder = async () => {
    const adet = onizleme?.gecerli || 0;
    if (adet === 0) { setHata('Listede geçerli cep telefonu bulunamadı.'); return; }
    if (!mesaj.trim()) { setHata('Lütfen yollanacak mesaj metnini yazınız.'); return; }
    if (!window.confirm(`${adet} adet TOPLU SMS yollamak istiyor musunuz?\n\nBu işlem geri alınamaz.`)) return;

    setGonderiliyor(true); setHata(''); setSonuc(null);
    try {
      const { data } = await api.post('/toplu-sms/gonder', { numaralar, mesaj, onaylandi: true });
      setSonuc(data);
      setBilgi(`${data.gecerli} numaraya SMS yollandı.`);
    } catch (err) {
      setHata(err.response?.data?.hata || 'SMS gönderilemedi.');
    } finally {
      setGonderiliyor(false);
    }
  };

  // VB6: Türkçe karakterler gönderimden önce sadeleştirilir (GSM 7-bit).
  const uzunluk = mesaj.length;
  const parca = uzunluk === 0 ? 0 : Math.ceil(uzunluk / 160);

  return (
    <div className="ts">
      <div className="ts-serit">
        <h2 className="ts-baslik">📣 Toplu SMS <span>· Randevu Modülü</span></h2>
        <div className={`ts-durum ${hata ? 'hata' : bilgi ? 'bilgi' : ''}`}>
          {hata || bilgi || 'Telefon listesini yapıştırın; mesaj tek seferde tüm numaralara gönderilir.'}
        </div>
      </div>

      <div className="ts-duzen">
        <div className="card ts-kutu">
          <label className="ts-etiket" htmlFor="ts-numaralar">Cep Telefonları</label>
          <p className="ts-not">
            Numaraları alt alta ya da virgülle yapıştırabilirsiniz; boşluk, tire ve parantez
            önemsenmez. Geçerli biçim: <b>05XXXXXXXXX</b> (ya da başında 0 olmadan 10 hane).
            En fazla 4000 numara.
          </p>
          <textarea id="ts-numaralar" rows={14} value={numaralar}
            onChange={e => setNumaralar(e.target.value)}
            placeholder={'0532 111 22 33\n0533 444 55 66\n...'} />
          {onizleme && (
            <div className="ts-ozet">
              <span className="yesil"><b>{onizleme.gecerli}</b> geçerli numara</span>
              {onizleme.mukerrer > 0 && <span><b>{onizleme.mukerrer}</b> mükerrer atlandı</span>}
              {onizleme.gecersiz > 0 && (
                <span className="kirmizi" title={onizleme.gecersizOrnekler?.join(', ')}>
                  <b>{onizleme.gecersiz}</b> geçersiz
                </span>
              )}
              {onizleme.kirpilan > 0 && <span className="kirmizi"><b>{onizleme.kirpilan}</b> sınır dışı</span>}
            </div>
          )}
        </div>

        <div className="card ts-kutu">
          <label className="ts-etiket" htmlFor="ts-mesaj">SMS Mesaj Metni</label>
          <p className="ts-not">
            Türkçe karakterler gönderimden önce sadeleştirilir (ç→c, ş→s, ğ→g, ö→o, ü→u, ı→i).
          </p>
          <textarea id="ts-mesaj" rows={7} value={mesaj} maxLength={900}
            onChange={e => setMesaj(e.target.value)} placeholder="Mesaj metni..." />
          <div className="ts-uzunluk">
            Mesaj uzunluğu: <b>{uzunluk}</b> / 160 {parca > 1 && <span className="kirmizi">({parca} SMS kontör)</span>}
          </div>

          <button type="button" className="ts-gonder" onClick={gonder}
            disabled={gonderiliyor || !(onizleme?.gecerli > 0) || !mesaj.trim()}>
            {gonderiliyor ? 'Gönderiliyor...' : `📣 ${onizleme?.gecerli || 0} NUMARAYA TOPLU SMS YOLLA`}
          </button>

          {sonuc && (
            <div className="ts-sonuc">
              <strong>Gönderim tamamlandı</strong>
              <div><span>Gönderilen numara</span><b>{sonuc.gecerli}</b></div>
              <div><span>Mesaj uzunluğu</span><b>{sonuc.uzunluk} karakter</b></div>
              {sonuc.saglayiciYaniti && (
                <div><span>Sağlayıcı yanıtı</span><b className="ts-yanit">{sonuc.saglayiciYaniti}</b></div>
              )}
              <p className="ts-not">Gönderilen mesaj: “{sonuc.mesaj}”</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
